<template>
  <div class="row">
    <section id="map-panel" class="map-wrapper-map col-12" role="region" aria-label="Service Map">
      <b-collapse id="map-collapse" @show="setUpData(serv), boundsUpdate()">
        <l-map
          ref="servicesmap"
          lg="12"
          class="d-flex col-12"
          style="height: 400px; width: 100%"
          :zoom="zoom"
          :options="{ scrollWheelZoom: false }"
          @load:bounds="bounds"
        >
          <l-tile-layer :url="url" :attribution="attribution" />
          <v-marker-cluster :options="clusterOptions">
            <l-marker
              v-for="(service, index) in servicesLatLng"
              :key="index"
              :icon="icon"
              :text="service.Description | checkValue"
              :lat-lng="getLatLong(service.latLng)"
              :options="{ alt: 'map marker for ' + service.locationObj.name }"
            >
              <l-popup ref="marker">
                <span v-if="service.serviceObj">
                  Service:
                  <router-link
                    class="nav-link"
                    :to="{
                      name: 'Service',
                      params: {
                        id: service.serviceObj.id,
                        name: encodeURIComponent(service.serviceObj.name),
                        servicedata: service.serviceObj,
                      },
                    }"
                    aria-label="View service infomation"
                    itemprop="url"
                  >
                    {{ service.serviceObj.name }}
                  </router-link>
                </span>
                Location:
                <router-link
                  class="nav-link"
                  :to="{
                    name: 'Location',
                    params: {
                      id: service.locationObj.id,
                      name: encodeURIComponent(service.locationObj.name),
                    },
                  }"
                  aria-label="View service infomation"
                  itemprop="url"
                >
                  {{ service.locationObj.name }}
                </router-link>
              </l-popup>
            </l-marker>
          </v-marker-cluster>
        </l-map>
      </b-collapse>
    </section>
  </div>
</template>

<script>
import * as Vue2Leaflet from 'vue2-leaflet'
import Vue2LeafletMarkercluster from 'vue2-leaflet-markercluster'

import 'leaflet.markercluster/dist/MarkerCluster.css'
import 'leaflet.markercluster/dist/MarkerCluster.Default.css'

export default {
  components: {
    LMap: Vue2Leaflet.LMap,
    LTileLayer: Vue2Leaflet.LTileLayer,
    LMarker: Vue2Leaflet.LMarker,
    LPopup: Vue2Leaflet.LPopup,
    'v-marker-cluster': Vue2LeafletMarkercluster,
  },
  filters: {
    checkValue: function (value) {
      if (!value) return ''
      return value
    },
  },
  props: {
    serv: {
      type: Array,
      default() {
        return []
      },
    },
    expand: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      clusterOptions: { weight: 1.5, color: '#222', opacity: 0.5 },
      serviceInfo: [],
      zoom: 5,
      center: L.latLng(51.4570335, -2.6069122),
      center2: L.latLng(51.4570331, -2.6069121),
      url: 'http://{s}.tile.osm.org/{z}/{x}/{y}.png',
      attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      // marker: L.latLng(362248, 174685),
      servicesLatLng: [],
      bounds: [],

      icon: L.icon({
        iconUrl:
          'https://www.livewellnorthlincolnshire.org.uk/wp-content/plugins/livewell-services-plugin/vue/src/assets/map-marker.svg',
        // shadowUrl: 'http://leafletjs.com/examples/custom-icons/leaf-shadow.png',
        iconSize: [34, 41],
        iconAnchor: [21, 40],
        popupAnchor: [-5, -40],
      }),
    }
  },
  computed: {
    mapObj() {
      if (this.$refs.servicesmap.mapObject) {
        return this.$refs.servicesmap.mapObject
      }
      return {}
    },
  },
  mounted() {
    if (this.expand == true) this.$root.$emit('bv::toggle::collapse', 'map-collapse')
  },
  updated: function () {
    this.$nextTick(function () {
      this.boundsUpdate()
    })
  },
  methods: {
    setUpData(data) {
      if (typeof data != 'undefined') {
        this.servicesLatLng = []
        if (this.serv[0] && this.serv[0].latitude) {
          this.processLocations()
        } else {
          this.processServices()
        }
        this.boundsUpdate()
      }
    },
    boundsUpdate() {
      const bounds = this.bounds
      const mapObj = this.mapObj
      if (bounds.length > 0) {
        setTimeout(function () {
          console.log('[Fit bounds]')
          mapObj.invalidateSize()
          mapObj.fitBounds(bounds, {
            padding: [30, 30],
          })
          mapObj.invalidateSize()
        }, 850)
      }
    },

    processLocations() {
      const self = this
      this.serv.forEach(function (location) {
        self.buildLocationData(location)
      })
      this.boundsUpdate()
    },

    buildLocationData(location, service = null) {
      console.log('here', location)
      if (location.latitude) {
        if (location.latitude > 0) {
          console.log('lat check')
          this.servicesLatLng.push({
            serviceObj: service,
            locationObj: location,
            latLng: {
              lat: location.latitude,
              lng: location.longitude,
            },
          })
          this.bounds.push({
            lat: location.latitude,
            lng: location.longitude,
          })
        }
      }
    },
    processServices() {
      console.log(this.serv)
      const self = this
      this.serv.forEach(function (sv) {
        if (sv.service_at_locations) {
          sv.service_at_locations.forEach(function (serviceLocations) {
            self.buildLocationData(serviceLocations.location, sv)
          })
        }
      })
      this.boundsUpdate()
    },

    // This helps it work
    getLatLong(latLng) {
      return latLng
    },
  },
}
</script>

<style>
.marker-cluster-small {
  background-color: rgb(138, 138, 245);
}

.marker-cluster-small div {
  background-color: rgb(78, 78, 246);
}
</style>
